import { ProductInformationWrapper } from "./ProductInformationWrapper";
import { ProductMetadataV2Skeleton } from "./ProductMetadataV2Skeleton";
import { ProductOverviewSectionSkeleton } from "./sections/ProductOverviewSectionSkeleton";

export function ProductInformationSkeleton() {
    return (
        <ProductInformationWrapper>
            <ProductMetadataV2Skeleton />
            <ProductOverviewSectionSkeleton />
        </ProductInformationWrapper>
    );
}
